import { useEffect } from "react";
import {
  createBrowserRouter,
  RouterProvider,
  Navigate,
} from "react-router-dom";
import { Authenticator, useAuthenticator } from "@aws-amplify/ui-react";
import AppRoutes from "./routes/AppRoutes";
import AuthContainer from "./pages/auth/AuthContainer";

// Protected route wrapper component
// function ProtectedRoute({ children }) {
//   const { route } = useAuthenticator((context) => [context.route]);

//   if (route !== "authenticated") {
//     return <Navigate to="/login" replace />;
//   }

//   return children;
// }

// Wrapper component to handle location-dependent hooks
function AppWrapper() {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, []);

  return <AppRoutes />;
}

function App() {
  const router = createBrowserRouter([
    {
      path: "/login",
      element: <AuthContainer />,
    },
    {
      path: "/*",
      element: <AppWrapper />,
    },
  ]);

  return (
    <>
      <Authenticator.Provider>
        <RouterProvider router={router} />
      </Authenticator.Provider>
    </>
  );
}

export default App;
